import { BaseFetch } from "../main-model"
export default class ReportEduDevPlanModel extends BaseFetch {
    getReportEduDevPlanBy = (data) =>
    this.authFetch({
      url: "report-edu-dev-plan/getReportEduDevPlanBy",
      method: "POST",
      body: JSON.stringify(data),
    })
}
